module.exports = __webpack_public_path__ + "img/37c07b5e831c46f7d09b3e4ead96daad.png";